import { RoadmapTasks } from "@models";
import { Alert, AlertColor, Link } from "@mui/material";
import { TemplateConfig } from "@types";
import { Fragment, MouseEvent } from "react";
import { useDocEngine } from "src/hooks/useDocEngine";

interface DocWarningsProps {
  incompleteTemplates: string[];
  isSuggestion?: boolean;
  size?: "small" | "medium";
  customTitle?: string;
  deviceId: string;
  templatesConfig: TemplateConfig;
  tasks: RoadmapTasks;
  severity?: AlertColor;
}

export const DocWarnings = ({
  incompleteTemplates,
  isSuggestion = false,
  size = "medium",
  customTitle,
  deviceId,
  templatesConfig,
  severity = "warning",
}: DocWarningsProps) => {
  const docEngine = useDocEngine(deviceId);

  if (incompleteTemplates.length === 0) {
    return null;
  }

  const handleDocumentClick = async (
    event: MouseEvent<HTMLAnchorElement>,
    templateKey: string
  ) => {
    event.preventDefault();
    await docEngine.navigateToWizardOrQMS({
      templateKey,
    });
  };

  const title = isSuggestion ? "suggestion" : "document";
  const defaultTitle = `This ${title} was generated with limited context because the following document ${incompleteTemplates.length > 1 ? "s are " : " is "} missing or incomplete:`;

  return (
    <Alert
      severity={severity}
      data-testid="doc-warnings"
      sx={{
        fontSize: size === "small" ? "0.9rem" : "1rem",
        padding: ".2rem 1rem",
      }}
    >
      {customTitle || defaultTitle}{" "}
      {incompleteTemplates.map((dep, index) => {
        const label = templatesConfig?.[dep]?.defaultTitle ?? dep;

        return (
          <Fragment key={dep}>
            <Link
              href="#"
              onClick={(event) => {
                void handleDocumentClick(event, dep);
              }}
              className="cursor-pointer"
            >
              {label}
            </Link>
            {index === incompleteTemplates.length - 1 ? ". " : ", "}
          </Fragment>
        );
      })}
    </Alert>
  );
};
